export function createConstant(stateName){
  return (action) => {
    return ['shoprite', stateName, action].join('/');
  }
}

export function getNextGoalAmount(bufferAmt=0) {
  if      (bufferAmt > 6) return 9;
  else if (bufferAmt > 3) return 6;
  else if (bufferAmt > 1) return 3;
  else                    return 1;
}



// WEBPACK FOOTER //
// ./src/redux/helpers.js